import React from 'react';
import { whyAiStonksFeatures } from '../data/mock';
import { Shield, TrendingUp, MessageSquare, Target } from 'lucide-react';

const iconMap = [Shield, MessageSquare, TrendingUp, Target];

const WhyAiStonks = () => {
  return (
    <section id="why-aistonks" className="section-container section-dark">
      <div className="section-header">
        <h2 className="section-title">Why AiStonks</h2>
        <p className="section-subtitle">Built for clarity, confidence, and long-term success</p>
      </div>

      <div className="features-grid">
        {whyAiStonksFeatures.map((feature, index) => {
          const Icon = iconMap[index];
          return (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <Icon className="w-8 h-8" />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyAiStonks;
